import { render, staticRenderFns } from "./AppNavigationHeaderViewMenu.vue?vue&type=template&id=13580819&"
import script from "./AppNavigationHeaderViewMenu.vue?vue&type=script&lang=js&"
export * from "./AppNavigationHeaderViewMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports